export enum OfferApiState {
  Active = 'active',
  Inactive = 'inactive',
  All = 'all',
}

export const DEFAULT_OFFER_API_STATE = OfferApiState.Active;
